import styled from 'styled-components';

const Wraper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #1e2637;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  background: white;
  height: 40px;
  padding: 0px 16px;
`;

const Row = styled.div`
  display: flex;
`;

export default {
  Wraper,
  Row,
};
